<template>
    <div class="container">
        <div class="hill-section" id="contact">
            <h3 class="title">Get in touch</h3>
            <div class="contact">
                <p>108Hill-Office &amp; Residence Dongpaina Road. Saphanthong Village, <br> Sisattanak District, Vientiane Capital, Lao PDR.</p>
                <hr>
                <p><span>Mobile:</span> (+856) 20 55049049, 020 55885011</p>
                <p><span>联系我们:</span> (+856) 20 55049049, 020 55885011</p>
                <p><span>お問い合わせ:</span> 020 55885011</p>
            </div>
            <div>
                <div class="social-icon-group">
                    <!-- <a href="">
                        <img src="../../public/image/whatsapp.png" alt="">
                    </a> -->
                    <a href="https://www.facebook.com/108hill/" target="_blank" class="facebook">
                        <img src="../../public/image/facebook.png" alt="">
                    </a>
                </div>
            </div>
            <div class="map">
                <iframe
                src="https://maps.google.com/maps?q=108hill&t=&z=19&ie=UTF8&iwloc=&output=embed"
                frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.hill-section{
    text-align: center;
    margin: 80px auto;
    max-width: 800px;
    padding: 20px;
    @include mobile{
      margin-top: 30px;
    }
    .title{
        margin-bottom: 10px;
        color: $color-sub;
    }
    .contact{
        hr{
            background-color: $color-sub;
            width: 50px;
            margin: 20px auto;
        }
        p{
            line-height: 2;
            color: $color-main;
            span{
                background-color: $color-sub;
                color: #fff;
                padding: 3px 5px;
            }
        }
    }
    
    .social-icon-group{
        cursor: pointer;
        width: 30px;
        margin: 20px auto;
    }
}
.map{
    margin-top: 30px;
    iframe{
        border: 2px solid $color-sub;
        width: 100%;
        height: 300px;
    }
    
}
</style>